import React from "react";


const ModalHeaderTitle = ({title}) => {


  return (
    <span>{title}</span>
  )

}

export default ModalHeaderTitle;
